export enum ValidationActionType {
  Validated = 0,
  TransferredToMe = 1,
}
